/** DOM を作る小さな部品。サーバー由来の文字列は必ず textContent で入れる（innerHTML は使わない） */

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  cls?: string,
  text?: string,
  attrs?: Record<string, string>,
): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text !== undefined) e.textContent = text;
  if (attrs) for (const [k, v] of Object.entries(attrs)) e.setAttribute(k, v);
  return e;
}

export function btn(cls: string, text: string, onClick?: (ev: MouseEvent) => void): HTMLButtonElement {
  const b = h('button', cls, text, { type: 'button' });
  if (onClick) b.addEventListener('click', onClick);
  return b;
}

const SVG_NS = 'http://www.w3.org/2000/svg';

/** 線画のアイコン（Lucide、ISC）。paths は d 属性、circle は [cx, cy, r] */
export function icon(cls: string, paths: string[], circle?: [number, number, number]): SVGSVGElement {
  const s = document.createElementNS(SVG_NS, 'svg');
  s.setAttribute('class', cls);
  s.setAttribute('viewBox', '0 0 24 24');
  s.setAttribute('aria-hidden', 'true');
  for (const d of paths) {
    const p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
  }
  if (circle) {
    const c = document.createElementNS(SVG_NS, 'circle');
    c.setAttribute('cx', String(circle[0]));
    c.setAttribute('cy', String(circle[1]));
    c.setAttribute('r', String(circle[2]));
    s.appendChild(c);
  }
  return s;
}

/** Lucide arrow-right-left */
export function swapIcon(): SVGSVGElement {
  return icon('pr-sw', ['m16 3 4 4-4 4', 'M20 7H4', 'm8 21-4-4 4-4', 'M4 17h16']);
}

/** Lucide camera */
export function cameraIcon(): SVGSVGElement {
  return icon('pr-cam', ['M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z'], [12, 13, 3]);
}

/** Enter/Space でも押せるようにする（button ではない要素を押せる形にする） */
export function pressable(e: HTMLElement, label: string | null, fn: () => void): void {
  e.tabIndex = 0;
  e.setAttribute('role', 'button');
  if (label) e.setAttribute('aria-label', label);
  e.addEventListener('click', fn);
  e.addEventListener('keydown', (ev) => {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      fn();
    }
  });
}

export function clear(e: Element): void {
  while (e.firstChild) e.removeChild(e.firstChild);
}
